import React, { useEffect, useState } from "react";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { useNavigate, useNavigationType } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import termBg from "../../../src/image/term-bg.png";

export default function TermsConditions() {
  document.title = "Nexawage Payroll | Terms & Conditions";
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="terms-page">
      {/* header */}
      <div className="term-condition">
        <div className="">
          <div className="header-container">
            <div className="logo" onClick={() => navigate("/")}>
              <img
                src="\assets\images\Nexawage_new_logo.png"
                alt="NexaWage Logo"
              />
              <h2>NexaWage Payroll</h2>
            </div>

            <div className="header-actions">
              <Button
                label="Login"
                className="p-button-rounded desktop-login"
                style={{
                  padding: "8px 26px",
                  borderRadius: "8px",
                  background: "#41486b",
                  color: "#fff",
                  fontSize: "16px",
                }}
                onClick={() => navigate("/login")}
              />

              <Button
                className="hamburger"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <i className={`pi ${menuOpen ? "pi-times" : "pi-bars"}`}></i>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage: `url(${termBg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>Terms & Conditions</h1>
            <p>
              Please read these terms and conditions carefully before using our
              website or services. By accessing or using NexaWage, you agree to
              be bound by the terms described below.
            </p>
          </div>
        </div>
      </section>

      {/* Terms Container */}
      <section className="terms-container">
        <div className="term-item">
          <h2>1. Use of Services</h2>
          <p>
            NexaWage Payroll provides payroll and compliance tools, including paystub
            generation and PD7A reporting. You are responsible for providing
            accurate employee and payroll data. Services are intended for lawful
            business use only.
          </p>
        </div>

        <Divider />

        <div className="term-item">
          <h2>2. Account & Access</h2>
          <p>
            You must create an account to access certain services. You are
            responsible for keeping your login credentials secure. NexaWage Payroll is
            not responsible for unauthorized access due to weak passwords or
            user negligence.
          </p>
        </div>

        <Divider />

        <div className="term-item">
          <h2>3. Payments & Subscriptions</h2>
          <p>
            Some services may require payment or subscription fees. All payments
            must be made in accordance with the selected plan. Refunds are
            subject to NexaWage’s refund policy (if applicable).
          </p>
        </div>

        <Divider />

        <div className="term-item">
          <h2>4. Data Accuracy & Liability</h2>
          <p>
            Payroll calculations depend on the data you provide. NexaWage Payroll is not
            liable for errors caused by incorrect or incomplete information.
            Users remain responsible for ensuring compliance with CRA and other
            legal obligations.
          </p>
        </div>

        <Divider />

        <div className="term-item">
          <h2>5. Intellectual Property</h2>
          <p>
            All content, trademarks, and software on NexaWage Payroll are owned by us.
            You may not copy, modify, or redistribute without permission.
          </p>
        </div>

        <Divider />

        <div className="term-item">
          <h2>6. Limitation of Liability</h2>
          <p>
            NexaWage Payroll is not responsible for indirect, incidental, or
            consequential damages. We provide services “as-is” without
            warranties of any kind.
          </p>
        </div>

        <Divider />

        <div className="term-item">
          <h2>7. Termination</h2>
          <p>
            NexaWage Payroll may suspend or terminate your access if you violate these
            terms. Users may stop using the services at any time.
          </p>
        </div>

        <Divider />

        <div className="term-item">
          <h2>8. Governing Law</h2>
          <p>
            These Terms shall be governed by the laws of Canada. Any disputes
            will be handled under Canadian jurisdiction.
          </p>
        </div>

        <Divider />

        <div className="term-item">
          <h2>9. Contact Us</h2>
          <p>
            For questions about these Terms & Conditions, please email us at:{" "}
            {""}
            <a href="mailto:payroll@nexawage.com" target="_blank">
              payroll@nexawage.com
            </a>
          </p>
        </div>
      </section>

      {/* Footer */}
      {/* <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h4>NexaWage</h4>
            <p>
              Smart payroll & compliance platform for Canadian businesses.
              Simplify payroll today with NexaWage.
            </p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a href="/">About Us</a>
              </li>
              <li>
                <a href="/terms-condition">Terms & Condition</a>
              </li>
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Based in Canada / India</p>
            <p>Phone: +1 XXX XXX XXXX</p>
            <p>
              Email:{" "}
              <a href="mailto:payroll@nexawage.com" target="_blank">
                payroll@nexawage.com
              </a>
            </p>
          </div>
          <div className="footer-section">
            <h4>Stay Updated</h4>
            <Button
              label="Login"
              className="p-button-rounded p-button-lg"
              style={{
                padding: "5px 16px",
                borderRadius: "10px",
                background: "#fff",
                color: "#111",
                fontSize: "14px",
                // border:"2px solid black"
              }}
              onClick={() => navigate("/login")}
            />
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} NexaWage. All rights reserved.</p>
        </div>
      </footer> */}

      <Footer />
    </div>
  );
}
